module.exports = __webpack_public_path__ + "resources/img/img_alyac2_en.1b7c9a065c55d0750d419e998862d4db.png";